import {useMemo} from 'react';
import {AttachmentMessageRow} from './Log/Messages/AttachmentMessageRow';
import {SelectOptionsMessageRow} from './Log/Messages/SelectOptionsMessageRow';
import {ButtonOptionsMessageRow} from './Log/Messages/ButtonOptionsMessageRow';
import {ArticlesMessageRow} from './Log/Messages/ArticlesMessageRow';
import {ButtonsMessageRow} from './Log/Messages/ButtonsMessageRow';
import {TextMessageRow} from './Log/Messages/TextMessageRow';
import {TextWithAttachmentsMessageRow} from './Log/Messages/TextWithAttachmentsMessageRow';
import {InlineDataMessageRow} from './Log/Messages/InlineDataMessageRow';
import {RichTextMessageRow} from './Log/Messages/RichTextMessageRow';
import {CustomPartMessageRow} from './Log/Messages/CustomPartMessageRow';
import {
  MessageComponentContext,
  MessageComponentRegistry,
} from './MessageComponentContext';
import {AgentCardCompat} from '../StripeAssistant/LiveAnswersV2/AgentCard/AgentCardCompat';
import {StructuredContentCompat} from '../StripeAssistant/LiveAnswersV2/StructuredContent/StructuredContentCompat';

export const DefaultMessageComponents: MessageComponentRegistry = {
  'attachment-conversation-message': AttachmentMessageRow,
  'select-options-conversation-message': SelectOptionsMessageRow,
  'button-options-conversation-message': ButtonOptionsMessageRow,
  'articles-conversation-message': ArticlesMessageRow,
  'buttons-conversation-message': ButtonsMessageRow,
  'text-conversation-message': TextMessageRow,
  'text-with-attachments-conversation-message': TextWithAttachmentsMessageRow,
  'inline-data-conversation-message': InlineDataMessageRow,
  'rich-text-conversation-message': RichTextMessageRow,
  'custom-part-conversation-message': CustomPartMessageRow,
  'tool-call': AgentCardCompat,
  'structured-content': StructuredContentCompat,
};

export function MessageComponentProvider({
  value = {},
  children,
}: {
  value?: MessageComponentRegistry;
  children: React.ReactNode;
}) {
  const components = useMemo(() => {
    return {...DefaultMessageComponents, ...value};
  }, [value]);

  return (
    <MessageComponentContext.Provider value={components}>
      {children}
    </MessageComponentContext.Provider>
  );
}
